import React from 'react';
import { Button } from 'semantic-ui-react';

import './UpsellCard.scss';
export const UpsellCard = ({
  title,
  body,
  linkTitle,
  color,
  onClick,
  isLoading,
  isComplete,
}) => {
  return (
    <div className="UpsellCard" style={{ background: color }}>
      <h3>{title}</h3>
      {body}
      {!isComplete && (
        <div>
          <Button primary onClick={onClick} loading={isLoading}>
            {linkTitle}
          </Button>
        </div>
      )}
    </div>
  );
};
export default UpsellCard;
